import { Injectable } from '@angular/core'
import { RestApiService } from '../rest-api/rest-api.service'
import { MatDialog } from '@angular/material/dialog'
import { Subject, Observable } from 'rxjs'
import { STRINGS } from '../../shared-components/constants'
import {
  APIResponse,
  GenerateSignedUrlsResponse,
} from '../../models/file-manager-response.models'

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    public RestApiService: RestApiService,
    public dialog: MatDialog
  ) {
    if (localStorage.getItem('warningPopup') === null) {
      localStorage.setItem('warningPopup', 'false')
    }
  }
  invoiceIdSubject = new Subject<any>()

  sendInvoiceId(invoiceId: any) {
    this.invoiceIdSubject.next(invoiceId)
  }

  getItemizationStatusDetails() {
    return this.RestApiService.get_API_New('Generic/fetchItemizationStatus')
  }

  getDeductionTypeDetails(value) {
    if (value && value === STRINGS.MEMO_CHAT) {
      return this.RestApiService.get_API_New(
        'Generic/fetchDeductionsTypeList?all=true'
      )
    } else {
      return this.RestApiService.get_API_New('Generic/fetchDeductionsTypeList')
    }
  }

  getRetailerTypeDetails() {
    return this.RestApiService.get_API_New('index/retailerConfigs')
  }

  getProcessingStatusDetails() {
    return this.RestApiService.get_API_New('Generic/fetchProcessingStatusList')
  }

  getDisputeStatusDetails() {
    return this.RestApiService.get_API_New('Generic/fetchDisputeStatusList')
  }

  downloadSignedUrl(value) {
    return this.RestApiService.get_API_New(
      `documents/download-file?file_path=${encodeURIComponent(value.file_path)}`
    )
  }

  invoiceDownload(value, table) {
    return this.RestApiService.fileDownLoad_Api_GZip(
      'Generic/downloadDocument/' + table,
      value
    )
  }

  fileUpload(value) {
    return this.RestApiService.file_Upload_Api('Generic/uploadfile', value)
  }

  promotionFileUpload(value) {
    return this.RestApiService.file_Upload_Api_Post('docs/upload', value)
  }

  deleteFile(value) {
    return this.RestApiService.delete_Api('docs/delete', value)
  }

  userList(type: any) {
    return this.RestApiService.get_API_New(
      `Generic/fetchUsersList?type=${type}`
    )
  }

  getCustomerDetails() {
    return this.RestApiService.get_API_New('Generic/fetchCustomersList')
  }

  deleteBackupDocument(data) {
    return this.RestApiService.post_Api('Generic/deleteInvoiceDocument', data)
  }

  getSignedUrls(
    files: string[],
    customerId?: number
  ): Observable<APIResponse<GenerateSignedUrlsResponse>> {
    return this.RestApiService.post_Api('documents/generate-upload-urls', {
      files,
      customer_id: customerId,
    }) as Observable<APIResponse<GenerateSignedUrlsResponse>>
  }

  uploadToSignedUrl(signedUrl: string, file: File, contentType?: string) {
    return this.RestApiService.put_SignedUrl_Api(signedUrl, file, contentType)
  }

  PromotionsUpload(value) {
    return this.RestApiService.file_Upload_Api_Post('promotions/create', value)
  }

  getUserInfo() {
    return this.RestApiService.get_API_New('index/fetchUserDetails')
  }

  itemizeDebitMemo(value) {
    return this.RestApiService.post_Api('debitmemo/itemize', value)
  }

  masterReport(value) {
    return this.RestApiService.post_Api(
      'reports/master_table' + '?download=' + value.download,
      value
    )
  }

  masterReport_download(value) {
    return this.RestApiService.file_DownLoad_Api(
      'reports/master_table' + '?download=' + value.download,
      value
    )
  }

  getDeductionsByCustomer(data) {
    return this.RestApiService.post_Api('reports/fetchReportingTable', data)
  }

  changeDocumentType(data) {
    return this.RestApiService.post_Api('documents/change_document_type', data)
  }

  getCustomerDedHeaders() {
    return this.RestApiService.get_API_New('reports/fetchReportsHeader')
  }

  fetchAllDocuments(data) {
    return this.RestApiService.get_API_New(
      `documents/fetchAllDocuments/${data.doc_type}/${data.id}`
    )
  }

  fetchDocumentType() {
    return this.RestApiService.get_API_New('documents/fetchDocumentType')
  }

  getInvoiceMessages() {
    return this.RestApiService.post_Api(
      `Generic/fetchAllNotificationMessage`,
      {}
    )
  }

  clearNotification(data) {
    return this.RestApiService.put_Api(
      `Generic/clearNotification?id=${data}`,
      {}
    )
  }

  getInvoiceProcessingStatus(invoiceId: any) {
    return this.RestApiService.get_API_New(
      `Generic/getdetails?table_name=invoices&column_name=processing_status&ids=${invoiceId}`
    )
  }

  addNotificationMessage(data) {
    return this.RestApiService.post_Api('Generic/addNotificationMessage', data)
  }

  searchUser(txt: any) {
    return this.RestApiService.get_API_New(
      `Generic/fetchUsersList?search=${txt}&type=0`
    )
  }

  getCustomerSubGroup(customerId) {
    return this.RestApiService.get_API_New(
      `Validations/fetchCustomerSubGroup?customer_id=${customerId}`
    )
  }

  splitRevert(data: any) {
    return this.RestApiService.post_Api('Validations/splitReverse', data)
  }

  getRetailerClaimTypes(customerId) {
    return this.RestApiService.get_API_New(
      `Generic/RetailerClaimTypes?customer_id=${customerId}`
    )
  }

  getRetailerDocumentType(customerId) {
    return this.RestApiService.get_API_New(
      `Generic/RetailerDocumentType?customer_id=${customerId}`
    )
  }

  getPromotionDropdownData() {
    return this.RestApiService.get_API_New(
      `promotions/configurations?all_configs=false`
    )
  }
}
